
const CoordinateSystems = [
  { value: 'NONE', name: '无' },
  { value: 'WSG84', name: 'WGS-84' },
  { value: 'GAODE', name: '高德（火星）坐标' },
  { value: 'BAIDU', name: '百度坐标' }
]
const CoordinateSystems2 = [
  { value: 'WSG84', name: 'WGS-84' },
  { value: 'GAODE', name: '高德（火星）坐标' },
  { value: 'BAIDU', name: '百度坐标' }
]
// 标注属性类型
const MarkerAttributeType = [
  { value: 'TEXT', name: '文本类型' },
  { value: 'NUMBER', name: '数值' },
  { value: 'DATE', name: '日期' },
  { value: 'DATE_TIME', name: '日期+时间' },
  { value: 'LINK', name: '网页链接' },
  { value: 'PHONE', name: '电话号码' },
  { value: 'LIVE', name: '直播源' }
]
const MarkerAttributeType2 = [
  { value: 'TEXT', name: '文本类型' },
  { value: 'NUMBER', name: '数值' },
  { value: 'DATE', name: '日期' },
  { value: 'DATE_TIME', name: '日期+时间' },
  { value: 'LINK', name: '网页链接' },
  { value: 'PHONE', name: '电话号码' },
  { value: 'LIVE', name: '直播源' },
  { value: 'SELECT', name: '下拉选项' }
]

// 权限等级
const PermissionLevel = {
  'CREATER': 4,
  'ADMINISTRATOR': 3,
  'COMPILER': 2,
  'LOOKER': 1,
  'ANONYM': 0
}

export {
  CoordinateSystems,
  CoordinateSystems2,
  MarkerAttributeType,
  MarkerAttributeType2,
  PermissionLevel
}

export default () => undefined
